<common-mojo-api-key-form
  (closeDialogEmit)="closeDialog()"
  [setTitle]="title"
  [setApiKey]="apiKey"
  [setForm]="form"
  [setScopesFormControl]="scopesFormControl"
  [setFlatTreeControl]="treeControl"
  [setDatasource]="dataSource"
  (saveData)="onSaveDos($event)"
  [setFlatNodeMap]="flatNodeMap"
  (revokeApiKeyEmit)="revokeApiKey()"
  (activateApiKeyEmit)="activateApiKey()"
></common-mojo-api-key-form>
